const channelSubSections = {
  EDIT_PUBLISHING_MANAGER: 'editPublishingManager',
};

export default channelSubSections;
